import { type FetchPledgeCampaignUserMeActivitySummaryByCampaignData, minutesToMs, pledgeApi } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

export const useUserPledgeCampaignActivitySummaryQuery = (campaignId: string) => {
	return useQuery({
		enabled: true,
		queryFn: async () => {
			return (await pledgeApi).fetchPledgeCampaignUserMeActivitySummaryByCampaign(
				campaignId
			) as Promise<FetchPledgeCampaignUserMeActivitySummaryByCampaignData>;
		},
		queryKey: ['user-pledge-activity-summary', campaignId],
		select: res => res.data,
		staleTime: minutesToMs(1)
	});
};
